import FeatureSection from '../components/common/sections/FeatureSection';
import HeroSection from "../components/common/sections/HeroSection";
import ImageListSection from '../components/common/sections/ImageListSection';
import MinimalCarousel from "../components/common/sections/MinimalCarousel";
import CtaSection from "../components/common/sections/cta/CtaSection";

const Home = ({t}) => {
    const carousel_data = [
      { image: '/images/carousel_home/carrousel_home1.jpeg', caption: t("pages.home.texts.text1") },
     { image: '/images/carousel_home/carrousel_home2.jpeg', caption: t("pages.home.texts.text1") },
     { image: '/images/carousel_home/carrousel_home3.jpeg', caption: t("pages.home.texts.text1") },
     ];
    
     const services = t("pages.services", { returnObjects: true });
     const services_title = services.title;
     const services_options = services.options;
     const services_items = Object.keys(services_options).map((key) => {
         const { title, homeEmoji, hideInHome } = services_options[key];
         if (hideInHome) return null;
         return homeEmoji + ' ' + title
     });

     const feature_section_booking = t("pages.home.feature_section_booking", { returnObjects: true });
     const feature_section_rates = updateFeatureSectionRates(t("pages.rates", { returnObjects: true }), t("pages.home.feature_section_rates", { returnObjects: true }));
     const feature_section_booking_overview = t("pages.home.feature_section_booking_overview", { returnObjects: true });
     const services_items_desktop = getServicesItems(t("pages.services", { returnObjects: true }));


    return (
      <div className="content">
        <MinimalCarousel  data={carousel_data} width="100%" height="500px"/>
        {/* <h1 className="content-h2">{t("pages.home.texts.text2")}</h1> */}
        <div className="schedule-section" style={{
          textAlign: 'center',
          padding: '15px 20px',
          margin: '20px auto',
          maxWidth: '500px',
          backgroundColor: '#0056b3',            // Verde fuerte y corporativo
          borderRadius: '10px',
          boxShadow: '0 4px 10px rgba(0,0,0,0.15)' // Sombra un poco más pronunciada para dar profundidad
        }}>
          <h2 style={{ 
            fontSize: '0.85rem',                 // Texto pequeño
            color: '#c8e6c9',                    // Verde muy claro para el título (contraste)
            textTransform: 'uppercase', 
            letterSpacing: '1px', 
            margin: '0 0 4px 0' 
          }}>
            {t("pages.home.schedule.title", "Horario de Apertura")}
          </h2>
          <p style={{ 
            fontSize: '1.1rem',                  // Texto pequeño/mediano
            fontWeight: 'bold', 
            color: '#ffffff',                    // Blanco puro para las horas (máxima legibilidad)
            margin: 0 
          }}>
            🕒 {t("pages.home.schedule.hours", "Todos los días de 7:00 a 21:00")}
          </p>
        </div>
        <div className="desktop">
          <FeatureSection
            title={t("pages.home.split_section.split_section1.text")}
            items={services_items_desktop}
            buttonText={feature_section_booking.button}
            buttonLink="/contact"
            image="/images/gallery/gallery1.jpeg"
            imagePosition='right'
            enableLightbox={true}
          />
          <HeroSection
            title={""}
            shortTitle={""}
            color="black"
            text={feature_section_rates.title}
            buttonText={feature_section_rates.button}
            buttonLink="/rates"
            image="/images/gallery/gallery5.jpeg"
            verticalAlign="bottom"
            horizontalAlign="left"
          />
        </div>

        <div className="mobile">
          <ImageListSection title={services_title} items={services_items} image="/images/gallery/photo15.jpg" imageSide="right"/>
          <div className="generic-separator" />
          <CtaSection 
            title={t("pages.home.split_section.split_section1.text")} 
            buttonText={feature_section_booking.button} 
            buttonLink="/contact"
            image="/images/gallery/gallery1.jpeg"
          />
          <CtaSection 
            title={feature_section_rates.title} 
            buttonText={feature_section_rates.button}
            buttonLink="/rates"
            image="/images/gallery/gallery2.jpeg"
          />
        </div>
      </div>
    )
  };

  export default Home;

  const getServicesItems = (services) => {
    const servicesOptions = services.options || {};
    const paragraphs = Object.keys(servicesOptions)
      .filter((key) => !servicesOptions[key].hideInHome)
      .map((key) => {
        const { title, homeEmoji } = servicesOptions[key];
        return `${homeEmoji} ${title}`;
      });
  
    return [
      {
        subtitle: services.title,
        paragraphs
      }
    ];
  };

  const updateFeatureSectionRates = (rates, feature) => { 
    const ratesOptions = rates.options || {};
    const offers = [];
  
    Object.keys(ratesOptions).forEach((key) => {
      const option = ratesOptions[key];
      if (option.duration) offers.push(`🔹 ${option.duration}`);
    });
  
    // Replace the paragraphs of the first item if it's empty
    if (
      feature &&
      Array.isArray(feature.items) &&
      feature.items[0] &&
      Array.isArray(feature.items[0].paragraphs) &&
      feature.items[0].paragraphs.length === 0
    ) {
      feature.items[0].paragraphs = offers;
    }
  
    return feature;
  }; 